import React, { useEffect } from 'react'
import { AUTHENTICATION_SERVICE } from '../../config/constants/env'

const RedirectInitiativeAuthService: React.FC = () => {
  useEffect(() => {
    window.location.href = `${AUTHENTICATION_SERVICE.WEB_URL}${window.location.pathname}`
  })

  return <div>Loading</div>
}

export default RedirectInitiativeAuthService
